import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Avatar, Menu, Typography, Space } from 'antd';
import { BankOutlined, CarOutlined, FileTextOutlined, WalletOutlined, BellOutlined, UserOutlined, SettingOutlined, LogoutOutlined, TeamOutlined, HomeOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../utils/responsive';
import ThemeToggle from '../components/ThemeToggle';

const { Text } = Typography;

interface AppSidebarProps {
  onLogout: () => void;
}

const AppSidebar: React.FC<AppSidebarProps> = ({ onLogout }) => {
  const { isMobile } = useResponsive();
  const { user, role } = useAuth();
  const location = useLocation();

  const userTabs = [
    { key: '/', label: 'خانه', icon: <HomeOutlined /> },
    { key: '/trips', label: 'سفرها', icon: <CarOutlined /> },
    { key: '/bookings', label: 'رزروها', icon: <FileTextOutlined /> },
    { key: '/wallet', label: 'کیف پول', icon: <WalletOutlined /> },
    { key: '/notifications', label: 'اعلان‌ها', icon: <BellOutlined /> },
    { key: '/profile', label: 'حساب کاربری', icon: <UserOutlined /> },
  ];

  const agencyTabs = [
    { key: '/agency', label: 'داشبورد آژانس', icon: <BankOutlined /> },
    { key: '/agency/leaderboard', label: 'رتبه‌بندی', icon: <TeamOutlined /> },
  ];

  const adminTabs = [
    { key: '/admin', label: 'پنل مدیریت', icon: <SettingOutlined /> },
    { key: '/admin/users', label: 'کاربران', icon: <UserOutlined /> },
    { key: '/admin/users/browse', label: 'مرور کاربران', icon: <TeamOutlined /> },
  ];

  let menuItems = [...userTabs];
  if (role === 'agency' || role === 'admin') {
    menuItems = [...menuItems, ...agencyTabs];
  }
  if (role === 'admin') {
    menuItems = [...menuItems, ...adminTabs];
  }

  const selectedKey =
    menuItems
      .map((item) => item.key)
      .filter((key) => location.pathname === key || (key !== '/' && location.pathname.startsWith(key)))
      .sort((a, b) => b.length - a.length)[0] ?? '/';

  const displayName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.phoneNumber ?? 'کاربر';

  const roleLabel =
    role === 'admin' ? 'مدیر سیستم' : role === 'agency' ? 'آژانس' : 'مسافر';

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: isMobile ? '16px' : '24px',
      }}
    >
      <div
        style={{
          marginBottom: '24px',
          padding: '16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          color: 'white',
        }}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Avatar
            size={isMobile ? 40 : 48}
            icon={<UserOutlined />}
            style={{ background: 'rgba(255,255,255,0.2)' }}
          />
          <div>
            <Text style={{ color: 'white', fontWeight: 'bold' }}>{displayName}</Text>
            <br />
            <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>{roleLabel}</Text>
          </div>
        </Space>
      </div>

      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        style={{ border: 'none', background: 'transparent', flex: 1 }}
        items={menuItems.map((item) => ({
          key: item.key,
          icon: item.icon,
          label: <NavLink to={item.key}>{item.label}</NavLink>,
        }))}
      />

      <div style={{ marginTop: 'auto', paddingTop: '16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <ThemeToggle />
        <Menu
          mode="inline"
          style={{ border: 'none', background: 'transparent' }}
          items={[
            {
              key: 'logout',
              icon: <LogoutOutlined />,
              label: 'خروج',
              onClick: onLogout,
              style: { color: '#ff4d4f' },
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AppSidebar;
